import { translate } from '@/lib/i18n';

/** TZ-docs/19-xatolik-kodlari.md — kod → foydalanuvchiga ko'rsatiladigan o'zbekcha matn */
export const ERROR_MESSAGES: Record<string, string> = {
  VALIDATION_ERROR: "Ma'lumotlar noto'g'ri",
  UNAUTHORIZED: 'Tizimga kiring',
  TOKEN_EXPIRED: 'Sessiya tugadi, qayta kiring',
  FORBIDDEN: 'Bu amalga ruxsatingiz yo‘q',
  AGENT_CANNOT_ORDER: 'Agent buyurtma bera olmaydi',
  REGISTRATION_CLOSED:
    "Ro'yxatdan o'tish yopiq. Do'koningizni qo'shish uchun agentga murojaat qiling",
  STORE_NOT_APPROVED:
    "Do'koningiz hali tasdiqlanmagan. Administrator arizangizni ko'rib chiqmoqda",
  STORE_ATTACH_FAILED: "Do'konni biriktirib bo'lmadi",
  DEBT_LIMIT_EXCEEDED: 'Qarz limiti oshdi, buyurtma berish mumkin emas',
  NOT_FOUND: 'Topilmadi',
  PHONE_TAKEN: 'Bu telefon raqam allaqachon ro‘yxatdan o‘tgan',
  ADMIN_LIMIT_REACHED: 'Maksimal 2 ta admin bo‘lishi mumkin',
  SHIFT_ALREADY_OPEN: 'Oldingi smena yopilmagan',
  SHIFT_CLOSED: 'Smena yopilgan, o‘zgartirib bo‘lmaydi',
  ALREADY_RATED_TODAY: 'Bugun allaqachon baholagansiz',
  STORE_IN_RED_ZONE: 'Do‘kon qizil zonada — tasdiq talab qilinadi',
  STOCK_CONFLICT: 'Qoldiq o‘zgardi, sahifani yangilang',
  ORDER_INVALID_STATUS: 'Buyurtma holati bu amalga mos emas',
  INSUFFICIENT_INGREDIENT: 'Masalliq yetarli emas',
  INSUFFICIENT_BREAD_STOCK: 'Novvoyxonada yetarli non yo‘q',
  INSUFFICIENT_COURIER_STOCK: 'Qo‘lingizda yetarli non yo‘q',
  INSUFFICIENT_CASH: 'Kassada yetarli pul yo‘q',
  DEFECT_EXCEEDS_PRODUCED: 'Brak soni ishlab chiqarilgandan ko‘p',
  PAYMENT_EXCEEDS_DEBT: 'To‘lov summasi qarzdan ko‘p',
  DATA_INTEGRITY_ERROR: "Ma'lumotlar bir-biriga mos kelmadi",
  TOO_MANY_REQUESTS: 'Juda ko‘p so‘rov, biroz kuting',
  TOO_MANY_ATTEMPTS: 'Ko‘p marta xato kiritildi, 15 daqiqadan keyin urinib ko‘ring',
  INTERNAL_ERROR: 'Tizimda xatolik. Administratorga murojaat qiling',
  SERVICE_UNAVAILABLE: 'Xizmat vaqtincha ishlamayapti',
  NETWORK_ERROR: 'Internet aloqasi yo‘q. Qayta urinib ko‘ring',
};

export function getErrorMessage(code: string | undefined): string {
  // `translate` funksiya ichida chaqiriladi — modul darajasida EMAS, shuning
  // uchun til o'zgarganda ham to'g'ri tilda qaytadi.
  const uz = !code ? ERROR_MESSAGES.INTERNAL_ERROR! : (ERROR_MESSAGES[code] ?? ERROR_MESSAGES.INTERNAL_ERROR!);
  return translate(uz);
}

/**
 * Ixtiyoriy xatodan foydalanuvchiga ko'rsatiladigan matn.
 *
 * `apiClient` interceptor'i har qanday HTTP xatosini `ApiError` ga
 * aylantiradi, shuning uchun odatda `err.message` yetarli. Lekin
 * mutatsiya `onError` ishlovchilariga `unknown` keladi va har joyda
 * `(err as any)?.response?.data?...` yozish tipni yo'qotadi — shu
 * yordamchi o'sha naqshni bir joyga yig'adi.
 *
 * `TypeError`/`ReferenceError` kabi dasturiy xatolar matni ("Cannot read
 * properties of undefined") foydalanuvchiga ko'rsatilmaydi — `fallback` chiqadi.
 * `ApiError` va oddiy `Error` ning `name` i `'Error'`.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error && err.name === 'Error' && err.message) return err.message;
  if (typeof err === 'string' && err) return err;
  return fallback;
}

/**
 * `VALIDATION_ERROR` details → `{ maydon: xabar }`. Formalar xatoni aynan
 * o'sha maydon ostida ko'rsatishi uchun (react-hook-form `setError`).
 */
export function apiFieldErrors(err: unknown): Record<string, string> {
  const details = (err as { details?: unknown } | null)?.details;
  if (!Array.isArray(details)) return {};
  const result: Record<string, string> = {};
  for (const d of details as Array<{ field?: unknown; message?: unknown }>) {
    if (typeof d?.field === 'string' && typeof d.message === 'string' && !(d.field in result)) {
      result[d.field] = d.message;
    }
  }
  return result;
}
